import { DateTime } from "luxon"
import { isStringOnlyWhitespace } from "../../../utilities/stringUtilities"

export default function UnitNotesRow({ note, onClick }) {
  const date = DateTime.fromISO(note.attributes['created-at'])

  const metaLine = `${date.toFormat('M/d/yy')}` +
    (note.attributes['created-by'] ? ` | ${note.attributes['created-by']}` : '') +
    (note.attributes.subject ? ` | ${note.attributes.subject}` : '')

  return (
    <div className="flex w-full py-2 px-2 lg:hover:bg-grey-700 text-grey-300 text-left border-b-2 border-grey-700" onClick={onClick}>
      <div className="flex flex-col w-full" data-testid="unit-note-row">
        <div className="text-sm">{metaLine}</div>
        <div className="text-grey-100">
          {note.attributes.note && !isStringOnlyWhitespace(note.attributes.note)
            ? note.attributes.note
            : note.attributes.subject}
        </div>
      </div>
    </div>
  )
}
